import { createClient } from 'graphql-ws';
import { getRequest, type Disposable } from 'relay-runtime';

import type { agentSessionEventsSubscription as Subscription } from './__generated__/agentSessionEventsSubscription.graphql';
import { agentSessionEventsSubscription } from './agentSessionEventsSubscription';

export const subscribeToHomeAgentSessionPayloads = (
	variables: Subscription['variables'],
	activationId: string,
	observer: {
		next: (data: Subscription['response']) => void;
		error: (error: unknown) => void;
		reconnect: () => void;
	},
): Disposable | undefined => {
	if (
		typeof window === 'undefined' ||
		!['home.atlassian.com', 'home.stg.atlassian.com'].includes(window.location.hostname)
	)
		return;
	const { params } = getRequest(agentSessionEventsSubscription);
	const build = window as Window & { BUILD_KEY?: string; SSR_BUILD_KEY?: string };
	let connected = false;
	const client = createClient({
		url: `${window.location.origin.replace(/^http/, 'ws')}/gateway/api/graphql/subscriptions/rovo/workspace/${encodeURIComponent(activationId)}`,
		lazy: true,
		keepAlive: 580_000,
		retryAttempts: 100,
		connectionParams: {
			'atl-client-name': 'jira-frontend',
			'atl-client-version': `${build.BUILD_KEY ?? ''}::${build.SSR_BUILD_KEY ?? ''}`,
			'X-ExperimentalApi': 'ConvoAiInboxSessionChanged',
		},
		on: {
			connected: () => {
				if (connected) observer.reconnect();
				connected = true;
			},
		},
	});
	const unsubscribe = client.subscribe<Subscription['response']>(
		{
			query: '',
			operationName: params.name,
			variables,
			extensions: { pq: params.id },
		},
		{
			next: ({ data, errors }) => {
				if (errors?.length) observer.error(new Error('Incomplete AgentSession event.'));
				else if (data) observer.next(data);
			},
			error: observer.error,
			complete: () => observer.error(new Error('AgentSession subscription completed.')),
		},
	);
	return {
		dispose: () => {
			unsubscribe();
			void client.dispose();
		},
	};
};
